module.exports = __webpack_public_path__ + "img/search-light.00558ec3.svg";